import React from "react";

const ParagraphSection = ({ title, children }) => {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-xl font-semibold">{title}</span>
      <p className="whitespace-pre-line text-muted-foreground">{children}</p>
    </div>
  );
};

export default ParagraphSection;
